import { createAction } from 'redux-actions';

export const CAPTURE_TAX = 'CAPTURE_TAX';
export const CAPTURE_TAX_SUCCESS = 'CAPTURE_TAX_SUCCESS';
export const CAPTURE_TAX_FAILED = 'CAPTURE_TAX_FAILED';

export const captureTaxAction = createAction(CAPTURE_TAX);
export const captureTaxSuccessAction = createAction(CAPTURE_TAX_SUCCESS);
export const captureTaxFailedAction = createAction(CAPTURE_TAX_FAILED);